import styled, { css } from 'styled-components';
import { shade } from 'polished';

const colors = {
    green: '#0a9e9e',
    dark: '#3f345f',
    blue: '#3139B6',
    black: '#32424E',
    white: '#F6F9FB',
    purple: '#977CE5',
    error: '#EC2A5F',
    success: '#30CB83',
}

const sizes = {
    title: '56px',
    large: '44px',
    big: '32px',
    medium: '24px',
    min: '18px',
    nano: '14px'
}

export const Container = styled.button`
    font-family: 'MontserratRegular',sans-serif;
    line-height: normal;
    font-size: ${(props) => sizes[props.size]};

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    transition: background-color 0.2s;
    cursor: pointer;
    width: ${(props) => props.width ? props.width:'60%'};
    padding: ${(props) => props.padding ? props.padding:'10px 20px'};
    margin: ${(props) => props.margin ? props.margin:'0'};

    ${(props) => props.format === 'outline' && css`
        background: #fff;
        border: 1px solid ${(props) => colors[props.color]};
        color: ${(props) => colors[props.color]};
        &:hover {
            background: ${(props) => colors[props.color]};
            color: #fff;
        }
    `};

    ${(props) => props.format === 'solid' && css`
        background: ${(props) => colors[props.color]};
        border: 2px solid ${(props) => colors[props.color]};
        color: ${(props) => props.color==='white' ? '#3f345f':'#fff'};
        &:hover {
            background: ${(props) => shade(0.2, colors[props.color])};
        }
    `};
`
